import { render, staticRenderFns } from "./followItem.vue?vue&type=template&id=662d4452&scoped=true"
import script from "./followItem.vue?vue&type=script&lang=js"
export * from "./followItem.vue?vue&type=script&lang=js"
import style0 from "./followItem.vue?vue&type=style&index=0&id=662d4452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662d4452",
  null
  
)

export default component.exports